import React, { Fragment } from 'react';
import FormPessoa from '../../../components/pessoa/form-pessoa/index';
import NavBar from '../../../components/layout/navbar/index';

export default function Pessoa(props) {
    const pessoaTemp = props.location.state.registroUnico;
    return (
        <Fragment>
            <NavBar />
            <FormPessoa pessoa={pessoaTemp} />
        </Fragment>
    )
}